import Loader from "../static/svg/loader.svg";
import imagePlaceholder from '../static/img/image.png'
import CloseDelete from "../static/svg/close-delete.svg";
import OpenLink from "../static/svg/openLink-w.svg";
import {ReactComponent as Close} from "../static/svg/close.svg";
import {ReactComponent as Cancel} from "../static/svg/cancel_icon.svg";
import {ReactComponent as ArrowBack} from "../static/icons/arrow_back.svg";
import {ReactComponent as NoteAdd} from "../static/icons/note_add.svg";
import {ReactComponent as PhotoAdd} from "../static/icons/add_layer.svg";
import {ReactComponent as StateBtnAdd} from "../static/icons/add_tabs.svg";
import {ReactComponent as Image} from "../static/icons/image.svg"
import {ReactComponent as Video} from "../static/icons/video.svg"
import {ReactComponent as Svg} from "../static/icons/svg.svg"
import {ReactComponent as Delete} from "../static/icons/delete.svg"
import {ReactComponent as Wysiwyg} from "../static/icons/add_text.svg"
import {ReactComponent as Visible} from "../static/icons/visibility.svg"
import {ReactComponent as VisibleOff} from "../static/icons/visibility_off.svg"
import {ReactComponent as Lock} from "../static/icons/lock.svg"
import {ReactComponent as LockOpen} from "../static/icons/lock_open.svg"
import {ReactComponent as AlignLeft} from "../static/icons/format_align_left.svg"
import {ReactComponent as AlignRight} from "../static/icons/format_align_right.svg"
import {ReactComponent as AlignCenter} from "../static/icons/format_align_center.svg"
import {ReactComponent as Desktop} from "../static/icons/desktop.svg"
import {ReactComponent as Desktop4k} from "../static/icons/desktop-4k.svg"
import {ReactComponent as Hd} from "../static/icons/hd.svg"
import {ReactComponent as Tablet} from "../static/icons/tablet.svg"
import {ReactComponent as CropFree} from "../static/icons/crop_free.svg"
import {ReactComponent as AlignHoriCenter} from "../static/icons/align_horizontal_center.svg"
import {ReactComponent as AlignHoriLeft} from "../static/icons/align_horizontal_left.svg"
import {ReactComponent as AlignHoriRight} from "../static/icons/align_horizontal_right.svg"
import {ReactComponent as AlignVertCenter} from "../static/icons/align_vertical_center.svg"
import {ReactComponent as AlignVertBottom} from "../static/icons/align_vertical_bottom.svg"
import {ReactComponent as AlignVertTop} from "../static/icons/align_vertical_top.svg"
import {ReactComponent as Sync} from "../static/icons/sync.svg"
import {ReactComponent as AddBox} from "../static/icons/add_box.svg"
import {ReactComponent as AddLink} from "../static/icons/add_link.svg"
import {ReactComponent as Linked} from "../static/icons/link.svg"
import {ReactComponent as LinkedOff} from "../static/icons/link_off.svg"
import {ReactComponent as Rectangle} from "../static/icons/shapes/rectangle.svg"
import {ReactComponent as Line} from "../static/icons/shapes/line.svg"
import {ReactComponent as Circle} from "../static/icons/shapes/circle.svg"
import {ReactComponent as Star} from "../static/icons/shapes/star.svg"
import {ReactComponent as Arc} from "../static/icons/shapes/arc.svg"
import {ReactComponent as Drawing} from "../static/icons/shapes/drawing.svg"
import {ReactComponent as Ellipse} from "../static/icons/shapes/ellipse.svg"
import {ReactComponent as Arrow} from "../static/icons/shapes/arrow.svg"
import {ReactComponent as LineHeight} from "../static/icons/format_line_spacing.svg"
import {ReactComponent as LetterSpacing} from "../static/icons/format_letter_spacing.svg"
import {ReactComponent as Undo} from "../static/icons/undo.svg"
import {ReactComponent as Redo} from "../static/icons/undo.svg"
import {ReactComponent as PageAdd} from "../static/icons/add_page.svg"
import {ReactComponent as Plus} from "../static/icons/plus.svg"
import {ReactComponent as ChevronDown} from "../static/icons/chevron_down.svg" 
import {ReactComponent as Pencil} from "../static/icons/edit_pencil.svg" 
import {ReactComponent as TabBtn} from "../static/icons/tab-icon.svg" 
import {ReactComponent as Caution} from "../static/icons/warning.svg"
import {ReactComponent as ExpandMore} from "../static/icons/expand_more.svg"
import {ReactComponent as Download} from "../static/icons/download.svg"
import {ReactComponent as AddTag} from "../static/icons/add_tag.svg"
import {ReactComponent as Folder} from "../static/icons/folder.svg"
import {ReactComponent as Filter} from "../static/icons/filter.svg"
import {ReactComponent as AddFolder} from "../static/icons/add_folder.svg"
import {ReactComponent as Ellipses} from "../static/icons/ellipses.svg"
import {ReactComponent as PhotoLibrary} from "../static/icons/photo_library.svg"
import {ReactComponent as AddCategory} from "../static/icons/add_category.svg"
import {ReactComponent as AddShapes} from "../static/icons/shapes/shapes.svg"
import {ReactComponent as AddTemplate} from "../static/icons/templates.svg"
import {ReactComponent as BulkUpload} from "../static/icons/bulk_upload.svg"
import {ReactComponent as Trash} from "../static/icons/trash.svg"
import {ReactComponent as AddPopUp} from "../static/icons/add_popup.svg"
import {ReactComponent as Globe} from "../static/icons/globe.svg"

import {ReactComponent as GalleryImages} from "../static/modules/expo_gallery_images.svg" 
import {ReactComponent as GalleryVideos} from "../static/modules/expo_gallery_videos.svg" 
import {ReactComponent as GalleryVrs} from "../static/modules/expo_gallery_vrs.svg" 
import {ReactComponent as ThreeD} from "../static/modules/expo_3d.svg"
import {ReactComponent as Documents} from "../static/modules/expo_documents.svg"
import {ReactComponent as Map} from "../static/modules/expo_map.svg"
import {ReactComponent as Presentation} from "../static/modules/expo_presentation.svg"
import {ReactComponent as Screensaver} from "../static/modules/expo_screensaver.svg"
import {ReactComponent as StackBuilding} from "../static/modules/expo_stackbuilding.svg"
import {ReactComponent as StackPlan} from "../static/modules/expo_stackplan.svg"
import {ReactComponent as Timeline} from "../static/modules/timeline-icon.svg"
import {ReactComponent as WebView} from "../static/modules/expo_webview.svg"


const icons = {
    "loader" : Loader,
    "imagePlaceholder": imagePlaceholder,
    "ArrowBack": ArrowBack,
    "Close": Close,
    "Cancel": Cancel,
    "NoteAdd": NoteAdd,
    "PhotoAdd": PhotoAdd,
    "PageAdd": PageAdd,
    "StateBtnAdd": StateBtnAdd,
    "Image": Image,
    "Video": Video,
    "Svg": Svg,
    "Delete": Delete,
    "Wysiwyg": Wysiwyg,
    "Visible": Visible,
    "VisibleOff": VisibleOff,
    "Lock": Lock,
    "LockOpen":LockOpen,
    "AlignLeft": AlignLeft,
    "AlignRight": AlignRight,
    "AlignCenter": AlignCenter,
    "Desktop": Desktop,
    "Desktop4k": Desktop4k,
    "Hd": Hd,
    "Tablet": Tablet,
    "CropFree": CropFree,
    "AlignHoriCenter": AlignHoriCenter,
    "AlignHoriLeft": AlignHoriLeft,
    "AlignHoriRight": AlignHoriRight,
    "AlignVertCenter": AlignVertCenter,
    "AlignVertBottom": AlignVertBottom,
    "AlignVertTop": AlignVertTop,
    "Sync": Sync,
    "AddBox": AddBox,
    "AddLink":AddLink,
    "Linked":Linked,
    "LinkedOff":LinkedOff,
    "Rectangle": Rectangle,
    "Line": Line,
    "Circle": Circle,
    "LineHeight": LineHeight,
    "LetterSpacing": LetterSpacing,
    "Undo": Undo,
    "Redo": Redo,
    "Plus": Plus,
    "ChevronDown":ChevronDown,
    "Pencil": Pencil,
    "TabBtn": TabBtn,
    'Caution': Caution,
    'GalleryImages': GalleryImages,
    'GalleryVideos': GalleryVideos,
    'GalleryVrs': GalleryVrs,
    'ThreeD': ThreeD,
    'Documents': Documents,
    'Map': Map,
    'Presentation': Presentation,
    'Screensaver': Screensaver,
    'StackBuilding': StackBuilding,
    'StackPlan': StackPlan,
    'ExpandMore': ExpandMore,
    'Download': Download,
    'AddTag': AddTag,
    'Folder': Folder,
    'Filter': Filter,
    'AddFolder': AddFolder,
    'Ellipses': Ellipses,
    'PhotoLibrary': PhotoLibrary,
    'AddCategory': AddCategory,
    'AddShapes': AddShapes,
    'Arc': Arc,
    'Drawing': Drawing,
    'Ellipse': Ellipse,
    'Star': Star,
    'Timeline': Timeline,
    'AddTemplate': AddTemplate,
    'Arrow': Arrow,
    'BulkUpload':BulkUpload,
    'Trash':Trash,
    'AddPopUp':AddPopUp,
    'Globe': Globe,
    'WebView': WebView
}
export default icons;